import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Geist / Geist Mono, self-hosted (no Google Fonts CDN) so the app renders its
// real typeface offline and at the edge. Weights match the design's usage.
import '@fontsource/geist/400.css';
import '@fontsource/geist/500.css';
import '@fontsource/geist/600.css';
import '@fontsource/geist/700.css';
import '@fontsource/geist-mono/400.css';
import '@fontsource/geist-mono/500.css';
import '@fontsource/geist-mono/600.css';
import '@fontsource/geist-mono/700.css';

import { App } from '@/App';
import '@/styles.css';

/*
 * Feature screens register themselves into the shell's slots. Importing every
 * `register.tsx` for its side effects here means a new screen is added by
 * creating one file under features/, with no edit to the shell. The glob is
 * empty until a feature ships, which is legal and renders an empty shell.
 */
import.meta.glob('./features/**/register.tsx', { eager: true });

// The offline layer: app shell + hashed assets + visited map tiles keep
// working with no link. Production only — a service worker in front of Vite's
// dev server serves yesterday's modules and turns HMR into a haunting.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js');
  });
}

const container = document.getElementById('root');
if (!container) throw new Error('#root is missing from index.html');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
